import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-spinner-3d',
    styleUrl: 'style.sass',
    shadow: true,
})

export class RentwareSpinner3d {
    @Prop() text: string = "Loading...";
    @Prop() info: string = "";

    numberOfRings = 2;
    numberOfSegments = 30;

    get spinnerBody(){
        let spinnerBody = "";

        for (let i = 0; i < this.numberOfRings; i++) {
            spinnerBody += '<div class="preloader__ring">';

            for (let j = 0; j < this.numberOfSegments; j++) {
                spinnerBody += '<div class="preloader__sector">';
                spinnerBody += this.text[j] || "";
                spinnerBody += '</div>';
            }

            spinnerBody += '</div>';
        }

        return spinnerBody;
    }

    render() {
        return (
            <div class="spinner-overlay">
                <div innerHTML={this.spinnerBody} class="preloader" />

                <rentware-spacer size="XL" />

                <div innerHTML={this.info} class="info" />
            </div>
        );
    }
}
